// Dependencies
import { FC, SVGProps } from "react";

// Styles
import {
  StyledMenuIcon,
  StyledMenuItem,
  StyledMenuLabel,
} from "./SideMenu.styled";

interface MenuItemProps {
  Icon: FC<SVGProps<SVGSVGElement>>;
  label: string;
  path: string;
}

const MenuItem: FC<MenuItemProps> = ({ Icon, label, path }) => {
  return (
    <StyledMenuItem to={path}>
      <StyledMenuIcon>
        <Icon />
      </StyledMenuIcon>
      <StyledMenuLabel variant={"h3"}>{label}</StyledMenuLabel>
    </StyledMenuItem>
  );
};

export default MenuItem;
